/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

export type VehicleUsageReferenceDtoStatus = typeof VehicleUsageReferenceDtoStatus[keyof typeof VehicleUsageReferenceDtoStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const VehicleUsageReferenceDtoStatus = {
  UNLOCKING: 'UNLOCKING',
  BLUETOOTH_UNLOCKING: 'BLUETOOTH_UNLOCKING',
  UNLOCK_FAILED: 'UNLOCK_FAILED',
  UNLOCKED: 'UNLOCKED',
  LOCKING: 'LOCKING',
  BLUETOOTH_LOCKING: 'BLUETOOTH_LOCKING',
  LOCK_FAILED: 'LOCK_FAILED',
  LOCKED: 'LOCKED',
} as const;
